export const SuccessMessage = "SUCCESS_MESSAGE";
export const ErrorMessage = "ERROR_MESSAGE";
export const ServiceUnavailable = "SERVICE_UNAVAILABLE";
